export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10953.19b91bcd.jpg";